import { Input_Attr_Lnk } from '../models/domain/input_attr_lnk';
import { CommonEnums } from '../common.enums';
import { ReusableDesignInstWrapper } from 'src/app/modules/design/transforms/reusabledesigninst/reusabledesigninst.wrapper';
import { TransformsUtil } from 'src/app/modules/design/transforms/transforms.util';
import { Attribute } from '../models/domain/attribute';
import { DatabaseWrappersFactory } from '../databases/database.wrappers.factory';

export class Input_Attr_LnksUtil {
    private static instance: Input_Attr_LnksUtil;

    static getInstance() {
        if (!Input_Attr_LnksUtil.instance) {
            Input_Attr_LnksUtil.instance = new Input_Attr_LnksUtil();
        }

        return Input_Attr_LnksUtil.instance;
    }

    /**
    * Input_Attr_LnksUtil is a singleton class, so use Input_Attr_LnksUtil.getInstance() method instead of creating new Input_Attr_LnksUtil().
    */
    private constructor() {

    }

    setReadOnlyProperties(input_Attr_Lnks: Array<Input_Attr_Lnk>, reusableDesignInstWrapper: ReusableDesignInstWrapper): void {
        let transformsUtil: TransformsUtil = TransformsUtil.getInstance();
        let transformIdsMap: Map<number, any> = new Map<number, any>();

        for (let i: number = 0; i < reusableDesignInstWrapper.reusableDesignInst.design.objects.length; i++) {
            let transform: any = reusableDesignInstWrapper.reusableDesignInst.design.objects[i];
            transformIdsMap.set(transformsUtil.getTransform_Id(transform), transform);
        }

        for (let i: number = 0; i < input_Attr_Lnks.length; i++) {
            let input_Attr_Lnk: Input_Attr_Lnk = input_Attr_Lnks[i];
            let transform: any = transformIdsMap.get(input_Attr_Lnk.input_Inst_Obj_Id);
            if (!transform) continue;

            let attribute: Attribute = transformsUtil.getAttribute(input_Attr_Lnk.input_Inst_Attr_Id, transform);
            if (!attribute) continue;

            input_Attr_Lnk.input_Inst_AttrNm = transformsUtil.getTransform_Nm(transform) + '.' + attribute.attrNm;
            input_Attr_Lnk.input_Inst_DTypNm = DatabaseWrappersFactory.getInstance().getDatatypeName(reusableDesignInstWrapper.designWrapper.dbTyp_Id, attribute.attrDTyp_Id);
        }
    }

    // setWarningForTgt_Attr_Lnks(objectWrapper) {
    //     for (let i = 0; i < objectWrapper.output.attributes.length; i++) {
    //         let outputAttribute = objectWrapper.output.attributes[i];

    //         let carryForwardAttribute = objectWrapper.carryForwardAttributeObjectsHMapIds[outputAttribute.lnk_Obj_Id + '-' + outputAttribute.lnk_Attr_Id];
    //         if (!carryForwardAttribute) continue;

    //         outputAttribute.valid_Cd = this.verifyFamily(outputAttribute, carryForwardAttribute, objectWrapper) ? "0" : "-1";
    //     }
    // }

    copy(input_Attr_Lnks: Array<Input_Attr_Lnk>): Array<Input_Attr_Lnk> {
        let input_Attr_LnksTmp: Array<Input_Attr_Lnk> = new Array<Input_Attr_Lnk>();

        for (let i: number = 0; i < input_Attr_Lnks.length; i++) {
            input_Attr_LnksTmp.push(Input_Attr_Lnk.parse(input_Attr_Lnks[i]));
        }

        return input_Attr_LnksTmp;
    }

    copyFrom(input_Attr_Lnks: Array<Input_Attr_Lnk>, input_Attr_LnksTmp: Array<Input_Attr_Lnk>): void {
        let input_Attr_LnksMap: Map<any, Input_Attr_Lnk> = new Map<any, Input_Attr_Lnk>();

        for (let i: number = 0; i < input_Attr_Lnks.length; i++) {
            let input_Attr_Lnk: Input_Attr_Lnk = input_Attr_Lnks[i] as Input_Attr_Lnk;
            input_Attr_LnksMap.set(input_Attr_Lnk.input_Inst_Obj_Id + "-" + input_Attr_Lnk.input_Inst_Attr_Id, input_Attr_Lnk);
        }
        input_Attr_Lnks.splice(0, input_Attr_Lnks.length);

        for (let i: number = 0; i < input_Attr_LnksTmp.length; i++) {
            let input_Attr_LnkTmp: Input_Attr_Lnk = input_Attr_LnksTmp[i] as Input_Attr_Lnk;
            let input_Attr_Lnk: Input_Attr_Lnk = input_Attr_LnksMap.get(input_Attr_LnkTmp.input_Inst_Obj_Id + "-" + input_Attr_LnkTmp.input_Inst_Attr_Id);

            if (input_Attr_Lnk) {
                input_Attr_Lnk.copyFrom(input_Attr_LnkTmp);
            } else {
                input_Attr_Lnk = Input_Attr_Lnk.parse(input_Attr_LnkTmp);
            }

            input_Attr_Lnks.push(input_Attr_Lnk);
        }
    }

    compare(input_Attr_Lnks: Array<Input_Attr_Lnk>, input_Attr_LnksTmp: Array<Input_Attr_Lnk>): string {
        if (input_Attr_Lnks.length != input_Attr_LnksTmp.length)
            return 'Input Attributes length mismatch.';

        for (let i: number = 0; i < input_Attr_Lnks.length; i++) {
            let input_Attr_Lnk: Input_Attr_Lnk = input_Attr_Lnks[i] as Input_Attr_Lnk;
            let input_Attr_LnkTmp: Input_Attr_Lnk = input_Attr_LnksTmp[i] as Input_Attr_Lnk;

            let diffString: string = input_Attr_Lnk.compare(input_Attr_LnkTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }

        return '';
    }

    toString(input_Attr_Lnks: Array<Input_Attr_Lnk>): string {
        let str: string = '';
        str += 'Input_Attr_Lnk length: ' + input_Attr_Lnks.length + ' ';

        for (let i: number = 0; i < input_Attr_Lnks.length; i++) {
            let input_attr_lnkTmp: Input_Attr_Lnk = input_Attr_Lnks[i] as Input_Attr_Lnk;
            str += input_attr_lnkTmp.toString();
        }
        return str;
    }

    getInputAttributeName(input_Attr_Lnk: Input_Attr_Lnk, objectWrapper) {

        for (var i = 0; i < objectWrapper.dataSubFlowWrapper.transformWrappers.length; i++) {
            var transformWrapper = objectWrapper.dataSubFlowWrapper.transformWrappers[i];
            if (transformWrapper.obj_Id != input_Attr_Lnk.input_Inst_Obj_Id) continue;

            if (transformWrapper.object.attributes) {
                for (var j = 0; j < transformWrapper.object.attributes.length; j++) {
                    var attribute = transformWrapper.object.attributes[j];

                    if (attribute.attr_Id == input_Attr_Lnk.input_Inst_Attr_Id) {
                        input_Attr_Lnk.input_Inst_AttrNm = transformWrapper.name + '.' + attribute.attrNm;
                        return transformWrapper.name + '.' + attribute.attrNm;
                    }
                }
            }

            break;
        }
        return '';
    }

    getInputAttributeDbTypeId ( input_Attr_Lnk:Input_Attr_Lnk, objectWrapper:any ) {

        for( let i:number = 0; i < objectWrapper.parentObjectWrapper.transformWrappers.length; i++ ) {
            let transformWrapper = objectWrapper.parentObjectWrapper.transformWrappers[i];
            if( transformWrapper.obj_Id != input_Attr_Lnk.input_Inst_Obj_Id ) continue;
            
            for( let j:number = 0; j < transformWrapper.object.attributes.length; j++ ) {
                let attribute:Attribute = transformWrapper.object.attributes[j];
                if( attribute.attr_Id == input_Attr_Lnk.input_Inst_Attr_Id ) {
                    return attribute.attrDTyp_Id;
                }
            }
            
            break;
        }
        return '';
    }

    // verifyFamily(selectedAttribute, parentAttribute, objectWrapper) {
    //     let databaseWrappersFactory: DatabaseWrappersFactory = DatabaseWrappersFactory.getInstance();

    //     let attribute = objectWrapper.sub_IdsHMap[selectedAttribute.attr_Id];//DIAttributesUtil.get( tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, targetWrapper.dataObjectWrapper.attributes );
    //     if (!attribute) return;

    //     let dbTyp_Id1 = objectWrapper.dbTyp_Id;
    //     let attrDTyp_Id1 = parentAttribute.attrDTyp_Id;

    //     let dbTyp_Id2 = objectWrapper.nativeDbTyp_Id;
    //     let attrDTyp_Id2 = selectedAttribute.attrDTyp_Id;

    //     let allowString = true;
    //     let intTolet = false;

    //     let isSameFamily = databaseWrappersFactory.isSameFamily(dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet);
    //     //let isSameFamily = DIDatabases.isSameFamily( dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet );

    //     if (!isSameFamily)
    //         return isSameFamily;

    //     let dataTypeName1 = '';
    //     let dataType1 = databaseWrappersFactory.getDatatype(dbTyp_Id1, attrDTyp_Id1);
    //     if (dataType1) dataTypeName1 = (dataType1.name).toLowerCase();

    //     let dataTypeName2 = '';
    //     let dataType2 = databaseWrappersFactory.getDatatype(dbTyp_Id2, attrDTyp_Id2);
    //     if (dataType2) dataTypeName2 = (dataType2.name).toLowerCase();

    //     if (dataTypeName1 == dataTypeName2)
    //         return true;

    //     return false;
    // }
}


